// src/components/Icons/index.js
import React from "react";

export const IconLogout = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#ffffff"
    {...props} // Cho phép truyền các thuộc tính khác từ bên ngoài
  >
    <path
      d="M19 2H4C2.89543 2 2 2.89543 2 4V19C2 20.1046 2.89543 21 4 21H19C20.1046 21 21 20.1046 21 19V4C21 2.89543 20.1046 2 19 2Z"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13 9L15.5 11.5L13 14M7.5 11.5L14.8912 11.5"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IconEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#ffffff"
    {...props} // Cho phép truyền các thuộc tính khác từ bên ngoài
  >
    <path
      d="M12.9999 20V22H14.9999L20.9999 16L18.9999 14L12.9999 20Z"
      stroke="#ffffff"
      strokeWidth="1.5"
    />
    <path
      d="M11.9999 2.5V9H18.4999M18.9999 11V9L11.9999 2H2.99994V22H8.99994"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);
export const IconTickBlue = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="inline-block text-green-500"
    role="img"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25C11.4388 1.25 10.9816 1.48611 10.5656 1.80358C10.1759 2.10089 9.74606 2.53075 9.24319 3.03367L9.20782 3.06904C8.69316 3.5837 8.24449 3.78626 7.55208 3.78626C7.4653 3.78626 7.35579 3.78318 7.23212 3.7797C6.91509 3.77078 6.50497 3.75924 6.14615 3.79027C5.62128 3.83566 4.96532 3.97929 4.46745 4.48134C3.9734 4.97955 3.83327 5.63282 3.78923 6.15439C3.75922 6.50995 3.77075 6.91701 3.77966 7.23178L3.77966 7.23181C3.78317 7.35581 3.78628 7.46549 3.78628 7.55206C3.78628 8.24448 3.58371 8.69315 3.06902 9.20784L3.03367 9.24319C2.53075 9.74606 2.10089 10.1759 1.80358 10.5655C1.48612 10.9816 1.25001 11.4388 1.25 12C1.25001 12.5611 1.48613 13.0183 1.80358 13.4344C2.10095 13.8242 2.53091 14.2541 3.03395 14.7571L3.06906 14.7922C3.40272 15.1258 3.56011 15.3422 3.64932 15.5464C3.73619 15.7453 3.78628 15.9971 3.78628 16.4479C3.78628 16.5347 3.7832 16.6442 3.77972 16.7679C3.7708 17.0849 3.75926 17.495 3.79029 17.8539C3.83569 18.3787 3.97933 19.0347 4.48139 19.5326C4.97961 20.0266 5.63287 20.1667 6.15443 20.2107C6.50997 20.2408 6.91703 20.2292 7.23179 20.2203C7.35581 20.2168 7.4655 20.2137 7.55206 20.2137C7.99328 20.2137 8.24126 20.2581 8.43645 20.3386C8.63147 20.4191 8.84006 20.5632 9.15424 20.8774C9.22129 20.9444 9.30963 21.0391 9.41153 21.1483L9.41176 21.1486L9.41179 21.1486L9.4118 21.1486C9.64176 21.3951 9.94071 21.7155 10.22 21.9596C10.6437 22.33 11.2516 22.75 12 22.75C12.7485 22.75 13.3563 22.33 13.7801 21.9596C14.0593 21.7155 14.3583 21.3951 14.5882 21.1486C14.6902 21.0392 14.7787 20.9445 14.8458 20.8773C15.1599 20.5632 15.3685 20.4191 15.5635 20.3386C15.7587 20.2581 16.0067 20.2137 16.4479 20.2137C16.5345 20.2137 16.6442 20.2168 16.7682 20.2203C17.083 20.2292 17.49 20.2408 17.8456 20.2107C18.3671 20.1667 19.0204 20.0266 19.5186 19.5326C20.0207 19.0347 20.1643 18.3787 20.2097 17.8539C20.2407 17.495 20.2292 17.0849 20.2203 16.7679L20.2203 16.7676C20.2168 16.644 20.2137 16.5346 20.2137 16.4479C20.2137 15.9971 20.2638 15.7453 20.3507 15.5464C20.4399 15.3422 20.5973 15.1258 20.9309 14.7922L20.9661 14.7571C21.4691 14.2541 21.8991 13.8242 22.1964 13.4344C22.5139 13.0183 22.75 12.5611 22.75 12C22.75 11.4388 22.5139 10.9816 22.1964 10.5655C21.8991 10.1759 21.4693 9.74607 20.9664 9.24322L20.931 9.20784C20.5973 8.87416 20.4399 8.65779 20.3507 8.45354C20.2638 8.25468 20.2137 8.00288 20.2137 7.55206C20.2137 7.46534 20.2168 7.35593 20.2203 7.23236L20.2203 7.2321C20.2292 6.91507 20.2407 6.50496 20.2097 6.14615C20.1643 5.62129 20.0207 4.96533 19.5187 4.46747C19.0205 3.97339 18.3672 3.83325 17.8456 3.78921C17.49 3.75919 17.083 3.77072 16.7682 3.77964C16.6442 3.78315 16.5345 3.78626 16.4479 3.78626C15.7553 3.78626 15.3067 3.58361 14.7922 3.06904L14.7568 3.03368C14.2539 2.53075 13.8241 2.10089 13.4344 1.80358C13.0184 1.48611 12.5612 1.25 12 1.25ZM15.7657 10.1432C16.1209 9.72033 16.0661 9.08954 15.6432 8.73432C15.2203 8.37909 14.5895 8.43394 14.2343 8.85683L10.6972 13.0676L9.66603 12.1469C9.25406 11.7791 8.6219 11.8149 8.25407 12.2269C7.88624 12.6388 7.92202 13.271 8.33399 13.6388L10.134 15.246C10.3357 15.4261 10.6018 15.5168 10.8716 15.4975C11.1413 15.4781 11.3918 15.3503 11.5657 15.1432L15.7657 10.1432Z"
      fill="#2e86ff"
    ></path>
  </svg>
);
export const IconTickGray = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="inline-block text-gray-500"
    role="img"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25C11.4388 1.25 10.9816 1.48611 10.5656 1.80358C10.1759 2.10089 9.74606 2.53075 9.24319 3.03367L9.20782 3.06904C8.69316 3.5837 8.24449 3.78626 7.55208 3.78626C7.4653 3.78626 7.35579 3.78318 7.23212 3.7797C6.91509 3.77078 6.50497 3.75924 6.14615 3.79027C5.62128 3.83566 4.96532 3.97929 4.46745 4.48134C3.9734 4.97955 3.83327 5.63282 3.78923 6.15439C3.75922 6.50995 3.77075 6.91701 3.77966 7.23178L3.77966 7.23181C3.78317 7.35581 3.78628 7.46549 3.78628 7.55206C3.78628 8.24448 3.58371 8.69315 3.06902 9.20784L3.03367 9.24319C2.53075 9.74606 2.10089 10.1759 1.80358 10.5655C1.48612 10.9816 1.25001 11.4388 1.25 12C1.25001 12.5611 1.48613 13.0183 1.80358 13.4344C2.10095 13.8242 2.53091 14.2541 3.03395 14.7571L3.06906 14.7922C3.40272 15.1258 3.56011 15.3422 3.64932 15.5464C3.73619 15.7453 3.78628 15.9971 3.78628 16.4479C3.78628 16.5347 3.7832 16.6442 3.77972 16.7679C3.7708 17.0849 3.75926 17.495 3.79029 17.8539C3.83569 18.3787 3.97933 19.0347 4.48139 19.5326C4.97961 20.0266 5.63287 20.1667 6.15443 20.2107C6.50997 20.2408 6.91703 20.2292 7.23179 20.2203C7.35581 20.2168 7.4655 20.2137 7.55206 20.2137C7.99328 20.2137 8.24126 20.2581 8.43645 20.3386C8.63147 20.4191 8.84006 20.5632 9.15424 20.8774C9.22129 20.9444 9.30963 21.0391 9.41153 21.1483L9.41176 21.1486L9.41179 21.1486L9.4118 21.1486C9.64176 21.3951 9.94071 21.7155 10.22 21.9596C10.6437 22.33 11.2516 22.75 12 22.75C12.7485 22.75 13.3563 22.33 13.7801 21.9596C14.0593 21.7155 14.3583 21.3951 14.5882 21.1486C14.6902 21.0392 14.7787 20.9445 14.8458 20.8773C15.1599 20.5632 15.3685 20.4191 15.5635 20.3386C15.7587 20.2581 16.0067 20.2137 16.4479 20.2137C16.5345 20.2137 16.6442 20.2168 16.7682 20.2203C17.083 20.2292 17.49 20.2408 17.8456 20.2107C18.3671 20.1667 19.0204 20.0266 19.5186 19.5326C20.0207 19.0347 20.1643 18.3787 20.2097 17.8539C20.2407 17.495 20.2292 17.0849 20.2203 16.7679L20.2203 16.7676C20.2168 16.644 20.2137 16.5346 20.2137 16.4479C20.2137 15.9971 20.2638 15.7453 20.3507 15.5464C20.4399 15.3422 20.5973 15.1258 20.9309 14.7922L20.9661 14.7571C21.4691 14.2541 21.8991 13.8242 22.1964 13.4344C22.5139 13.0183 22.75 12.5611 22.75 12C22.75 11.4388 22.5139 10.9816 22.1964 10.5655C21.8991 10.1759 21.4693 9.74607 20.9664 9.24322L20.931 9.20784C20.5973 8.87416 20.4399 8.65779 20.3507 8.45354C20.2638 8.25468 20.2137 8.00288 20.2137 7.55206C20.2137 7.46534 20.2168 7.35593 20.2203 7.23236L20.2203 7.2321C20.2292 6.91507 20.2407 6.50496 20.2097 6.14615C20.1643 5.62129 20.0207 4.96533 19.5187 4.46747C19.0205 3.97339 18.3672 3.83325 17.8456 3.78921C17.49 3.75919 17.083 3.77072 16.7682 3.77964C16.6442 3.78315 16.5345 3.78626 16.4479 3.78626C15.7553 3.78626 15.3067 3.58361 14.7922 3.06904L14.7568 3.03368C14.2539 2.53075 13.8241 2.10089 13.4344 1.80358C13.0184 1.48611 12.5612 1.25 12 1.25ZM15.7657 10.1432C16.1209 9.72033 16.0661 9.08954 15.6432 8.73432C15.2203 8.37909 14.5895 8.43394 14.2343 8.85683L10.6972 13.0676L9.66603 12.1469C9.25406 11.7791 8.6219 11.8149 8.25407 12.2269C7.88624 12.6388 7.92202 13.271 8.33399 13.6388L10.134 15.246C10.3357 15.4261 10.6018 15.5168 10.8716 15.4975C11.1413 15.4781 11.3918 15.3503 11.5657 15.1432L15.7657 10.1432Z"
      fill="#6f6f6f"
    />
  </svg>
);
export const IconNote = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#4a90e2"
    {...props} // Cho phép truyền các thuộc tính khác từ bên ngoài
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 1.25L3.25141 22.75L13.3609 22.75L20.75 15.3709L20.75 1.25H3.25ZM18.7995 14.5399L12.5625 20.7949L12.5625 14.5399L18.7995 14.5399ZM7.25 5.25L16.75 5.25V6.75L7.25 6.75V5.25ZM12.75 9.25L7.25 9.25V10.75H12.75V9.25Z"
      fill="#4a90e2"
    />
  </svg>
);
export const IconJob = (props) => (
  <svg
    className="w-4 fill-current text-blue-900"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path d="M9 12H1v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6h-8v2H9v-2zm0-1H0V5c0-1.1.9-2 2-2h4V2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h4a2 2 0 0 1 2 2v6h-9V9H9v2zm3-8V2H8v1h4z" />
  </svg>
);
export const IconUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#4a90e2"
    {...props} // Cho phép truyền các thuộc tính khác từ bên ngoài
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 21C3.25 16.7198 6.71979 13.25 11 13.25H13C17.2802 13.25 20.75 16.7198 20.75 21C20.75 21.4142 20.4142 21.75 20 21.75H4C3.58579 21.75 3.25 21.4142 3.25 21Z"
      fill="#4a90e2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.25 7C7.25 4.37665 9.37665 2.25 12 2.25C14.6234 2.25 16.75 4.37665 16.75 7C16.75 9.62335 14.6234 11.75 12 11.75C9.37665 11.75 7.25 9.62335 7.25 7Z"
      fill="#4a90e2"
    />
  </svg>
);
export const IconFavorite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#4a90e2"
    {...props} // Cho phép truyền các thuộc tính khác từ bên ngoài
  >
    <path
      d="M11.9553 3.70845L11.9997 3.7438L12.044 3.70846C12.4134 3.41639 12.9531 3.05089 13.636 2.75875C15.0217 2.16591 16.9799 1.88758 19.2119 3.08156C21.9945 4.57002 23.3601 8.13311 22.4862 11.8026C21.6023 15.5144 18.4614 19.3368 12.2626 21.6518L11.9997 21.75L11.7367 21.6518C5.53788 19.3368 2.39701 15.5144 1.51304 11.8026C0.639129 8.13311 2.00471 4.57002 4.78724 3.08155C7.01925 1.88756 8.97747 2.16591 10.3632 2.75874C11.0461 3.05088 11.5858 3.41638 11.9553 3.70845Z"
      fill="#4a90e2"
    />
  </svg>
);
export const HandPointingLeftIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#4a90e2"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5515 3.78738L14.5527 3.78831L20.2558 8.25H22C22.4142 8.25 22.75 8.58579 22.75 9V18C22.75 18.4142 22.4142 18.75 22 18.75H20.1551L17.9998 19.6813C17.2226 20.0522 16.0631 20.4986 14.8931 20.6737C13.7529 20.8445 12.3751 20.789 11.4332 19.8531C9.38616 17.819 8.81064 15.1139 8.74751 13.25H3.75C2.36929 13.25 1.25 12.1307 1.25 10.75C1.25 9.36929 2.36929 8.25 3.75 8.25L12.1242 8.25L11.1542 7.32666C11.1386 7.31182 11.1236 7.29632 11.1094 7.2802C10.1793 6.22827 10.3388 4.63524 11.4457 3.77682C12.3564 3.07049 13.6457 3.07481 14.5515 3.78738Z"
      fill="#4a90e2"
    />
  </svg>
);
export const BlockedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="injected-svg"
    role="img"
    color="#ffffff"
    {...props} // Để có thể truyền thêm thuộc tính nếu cần
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1662 1.53871C12.4391 1.15376 11.5609 1.15376 10.8338 1.53871C9.63189 2.17509 7.1696 3.32075 4.21644 3.8341C3.12696 4.02349 2.25 4.95478 2.25 6.12325L2.25 11.0511C2.25 14.5419 4.02964 17.2085 5.99214 19.0834C7.95205 20.9559 10.152 22.0975 11.1534 22.5619C11.6943 22.8127 12.3057 22.8127 12.8466 22.5619C13.848 22.0975 16.0479 20.9559 18.0079 19.0834C19.9704 17.2085 21.75 14.5419 21.75 11.0511L21.75 6.12325C21.75 4.95478 20.873 4.02349 19.7836 3.8341C16.8304 3.32075 14.3681 2.17509 13.1662 1.53871ZM14.5 8.75V9.75C15.4665 9.75 16.25 10.5335 16.25 11.5L16.25 15C16.25 15.9665 15.4665 16.75 14.5 16.75L9.5 16.75C8.5335 16.75 7.75 15.9665 7.75 15L7.75 11.5C7.75 10.5335 8.5335 9.75 9.5 9.75V8.75C9.5 7.36929 10.6193 6.25 12 6.25C13.3807 6.25 14.5 7.36929 14.5 8.75ZM12 7.75C11.4477 7.75 11 8.19772 11 8.75V9.75H13V8.75C13 8.19772 12.5523 7.75 12 7.75Z"
      fill="#ffffff"
    />
  </svg>
);
export const ArrowRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#ffffff"
  >
    <path d="M7.50003 4V20L16.5 12L7.50003 4Z" fill="#ffffff" />
  </svg>
);
export const ArrowLeftIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#ffffff"
  >
    <path d="M16.5 4L7.50003 12L16.5 20V4Z" fill="#ffffff" />
  </svg>
);
export const ClipBoardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "24"}
    height={props.height || "24"}
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color={props.color || "#ffffff"}
  >
    <path
      d="M7.5 3C7.5 2.0335 8.2835 1.25 9.25 1.25H14.75C15.7165 1.25 16.5 2.0335 16.5 3C16.5 3.9665 15.7165 4.75 14.75 4.75H9.25C8.2835 4.75 7.5 3.9665 7.5 3Z"
      fill={props.color || "#ffffff"}
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 3.00113C6.25 2.9125 6.17409 2.84079 6.08629 2.8529C5.18618 2.97705 4.43852 3.24236 3.84811 3.83332C3.24631 4.43567 2.9875 5.19403 2.86651 6.09477C2.74997 6.96244 2.74998 8.06574 2.75 9.43465L2.75 16.0504C2.74998 17.4193 2.74997 18.5226 2.86651 19.3903C2.9875 20.291 3.24631 21.0494 3.84811 21.6517C4.44999 22.2542 5.20792 22.5133 6.10816 22.6345C6.97517 22.7512 8.07752 22.7511 9.44506 22.7511L14.5549 22.7511C15.9225 22.7512 17.0248 22.7512 17.8918 22.6345C18.7921 22.5133 19.55 22.2542 20.1519 21.6517C20.7537 21.0494 21.0125 20.291 21.1335 19.3903C21.25 18.5226 21.25 17.4193 21.25 16.0503L21.25 9.43469C21.25 8.06574 21.25 6.96246 21.1335 6.09477C21.0125 5.19403 20.7537 4.43567 20.1519 3.83332C19.5615 3.24236 18.8138 2.97705 17.9137 2.8529C17.8259 2.84079 17.75 2.9125 17.75 3.00113C17.75 4.65798 16.4069 6.00113 14.75 6.00113L9.25 6.00113C7.59315 6.00113 6.25 4.65798 6.25 3.00113ZM8.00196 10.2499C7.58774 10.2499 7.25196 10.5857 7.25196 10.9999C7.25196 11.4142 7.58774 11.7499 8.00196 11.7499L16.002 11.7499C16.4162 11.7499 16.752 11.4142 16.752 10.9999C16.752 10.5857 16.4162 10.2499 16.002 10.2499L8.00196 10.2499ZM8.00196 15.2499C7.58774 15.2499 7.25196 15.5857 7.25196 15.9999C7.25196 16.4142 7.58774 16.7499 8.00196 16.7499H12.002C12.4162 16.7499 12.752 16.4142 12.752 15.9999C12.752 15.5857 12.4162 15.2499 12.002 15.2499H8.00196Z"
      fill={props.color || "#ffffff"}
    ></path>
  </svg>
);
export const CancelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#ffffff"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8841 4.11599C20.3722 4.60415 20.3722 5.39561 19.8841 5.88376L5.88407 19.8838C5.39591 20.3719 4.60445 20.3719 4.1163 19.8838C3.62814 19.3956 3.62814 18.6041 4.1163 18.116L18.1163 4.11599C18.6045 3.62784 19.3959 3.62784 19.8841 4.11599Z"
      fill="#ffffff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.1163 4.11599C4.60445 3.62784 5.39591 3.62784 5.88407 4.11599L19.8841 18.116C20.3722 18.6041 20.3722 19.3956 19.8841 19.8838C19.3959 20.3719 18.6045 20.3719 18.1163 19.8838L4.1163 5.88376C3.62814 5.39561 3.62814 4.60415 4.1163 4.11599Z"
      fill="#ffffff"
    />
  </svg>
);
export const InstagramIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="injected-svg"
    data-src="https://cdn.hugeicons.com/icons/instagram-duotone-rounded.svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    role="img"
    color="#4a90e2"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.89124 3.89124C2.5 5.28249 2.5 7.52166 2.5 12C2.5 16.4783 2.5 18.7175 3.89124 20.1088C5.28249 21.5 7.52166 21.5 12 21.5C16.4783 21.5 18.7175 21.5 20.1088 20.1088C21.5 18.7175 21.5 16.4783 21.5 12C21.5 7.52166 21.5 5.28249 20.1088 3.89124C18.7175 2.5 16.4783 2.5 12 2.5C7.52166 2.5 5.28249 2.5 3.89124 3.89124ZM12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z"
      fill="#4a90e2"
    ></path>
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke="#4a90e2"
      strokeWidth="1.5"
      strokeLinejoin="round"
    ></path>
    <path
      d="M16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12Z"
      stroke="#4a90e2"
      strokeWidth="1.5"
    ></path>
    <path
      d="M17.5078 6.5L17.4988 6.5"
      stroke="#4a90e2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export const FacebookIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    color="#4a90e2"
  >
    <path
      opacity="0.4"
      d="M12.0572 1.75H11.9428C9.75214 1.74999 8.03143 1.74998 6.68802 1.93059C5.31137 2.11568 4.21911 2.50271 3.36091 3.36091C2.50272 4.21911 2.11568 5.31137 1.93059 6.68802C1.74998 8.03144 1.74999 9.75212 1.75 11.9428V12.0572C1.74999 14.2479 1.74998 15.9686 1.93059 17.312C2.11568 18.6886 2.50272 19.7809 3.36091 20.6391C4.21911 21.4973 5.31137 21.8843 6.68802 22.0694C8.03144 22.25 9.7521 22.25 11.9428 22.25H12.0572C14.2479 22.25 15.9686 22.25 17.312 22.0694C18.6886 21.8843 19.7809 21.4973 20.6391 20.6391C21.4973 19.7809 21.8843 18.6886 22.0694 17.312C22.25 15.9686 22.25 14.2479 22.25 12.0572V11.9428C22.25 9.75214 22.25 8.03144 22.0694 6.68802C21.8843 5.31137 21.4973 4.21911 20.6391 3.36091C19.7809 2.50271 18.6886 2.11568 17.312 1.93059C15.9686 1.74998 14.2479 1.74999 12.0572 1.75Z"
      fill="#4a90e2"
    />
    <path
      d="M17 6.75001L15.9217 6.75C15.0461 6.74993 14.2675 6.74986 13.6389 6.83438C12.9557 6.92624 12.2658 7.13806 11.7019 7.70191C11.138 8.26577 10.9262 8.95567 10.8344 9.63891C10.7499 10.2675 10.7499 11.0461 10.75 11.9217L10.75 12.75H10C9.30964 12.75 8.75 13.3097 8.75 14C8.75 14.6904 9.30964 15.25 10 15.25H10.75V22.2488C11.1312 22.25 11.5286 22.25 11.9428 22.25H12.0572C12.4714 22.25 12.8688 22.25 13.25 22.2488V15.25H15C15.6904 15.25 16.25 14.6904 16.25 14C16.25 13.3097 15.6904 12.75 15 12.75H13.25V12C13.25 11.0219 13.2527 10.414 13.3121 9.97202C13.3657 9.57311 13.4449 9.49432 13.4685 9.47088L13.4697 9.46968L13.4709 9.46847C13.4943 9.44492 13.5731 9.36572 13.972 9.31209C14.414 9.25266 15.0219 9.25001 16 9.25001H17C17.6904 9.25001 18.25 8.69036 18.25 8.00001C18.25 7.30965 17.6904 6.75001 17 6.75001Z"
      fill="#4a90e2"
    />
  </svg>
);
export const ZaloIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 50 50"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.782 0.166016H27.199C33.2653 0.166016 36.8103 1.05701 39.9572 2.74421C43.1041 4.4314 45.5875 6.89585 47.2557 10.0428C48.9429 13.1897 49.8339 16.7347 49.8339 22.801V27.1991C49.8339 33.2654 48.9429 36.8104 47.2557 39.9573C45.5685 43.1042 43.1041 45.5877 39.9572 47.2559C36.8103 48.9431 33.2653 49.8341 27.199 49.8341H22.8009C16.7346 49.8341 13.1896 48.9431 10.0427 47.2559C6.89583 45.5687 4.41243 43.1042 2.7442 39.9573C1.057 36.8104 0.166016 33.2654 0.166016 27.1991V22.801C0.166016 16.7347 1.057 13.1897 2.7442 10.0428C4.43139 6.89585 6.89583 4.41245 10.0427 2.74421C13.1707 1.05701 16.7346 0.166016 22.782 0.166016Z"
      fill="#0068FF"
    />
    <path
      opacity="0.12"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.8336 26.4736V27.1994C49.8336 33.2657 48.9427 36.8107 47.2555 39.9576C45.5683 43.1045 43.1038 45.5879 39.9569 47.2562C36.81 48.9434 33.265 49.8344 27.1987 49.8344H22.8007C17.8369 49.8344 14.5612 49.2378 11.8104 48.0966L7.27539 43.4267L49.8336 26.4736Z"
      fill="#001A33"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.779 43.5892C10.1019 43.846 13.0061 43.1836 15.0682 42.1825C24.0225 47.1318 38.0197 46.8954 46.4923 41.4732C46.8209 40.9803 47.1279 40.4677 47.4128 39.9363C49.1062 36.7779 50.0004 33.22 50.0004 27.1316V22.7175C50.0004 16.629 49.1062 13.0711 47.4128 9.91273C45.7385 6.75436 43.2461 4.28093 40.0877 2.58758C36.9293 0.894239 33.3714 0 27.283 0H22.8499C17.6644 0 14.2982 0.652754 11.4699 1.89893C11.3153 2.03737 11.1636 2.17818 11.0151 2.32135C2.71734 10.3203 2.08658 27.6593 9.12279 37.0782C9.13064 37.0921 9.13933 37.1061 9.14889 37.1203C10.2334 38.7185 9.18694 41.5154 7.55068 43.1516C7.28431 43.399 7.37944 43.5512 7.779 43.5892Z"
      fill="white"
    />
    <path
      d="M20.5632 17H10.8382V19.0853H17.5869L10.9329 27.3317C10.7244 27.635 10.5728 27.9194 10.5728 28.5639V29.0947H19.748C20.203 29.0947 20.5822 28.7156 20.5822 28.2606V27.1421H13.4922L19.748 19.2938C19.8428 19.1801 20.0134 18.9716 20.0893 18.8768L20.1272 18.8199C20.4874 18.2891 20.5632 17.8341 20.5632 17.2844V17Z"
      fill="#0068FF"
    />
    <path
      d="M32.9416 29.0947H34.3255V17H32.2402V28.3933C32.2402 28.7725 32.5435 29.0947 32.9416 29.0947Z"
      fill="#0068FF"
    />
    <path
      d="M25.814 19.6924C23.1979 19.6924 21.0747 21.8156 21.0747 24.4317C21.0747 27.0478 23.1979 29.171 25.814 29.171C28.4301 29.171 30.5533 27.0478 30.5533 24.4317C30.5723 21.8156 28.4491 19.6924 25.814 19.6924ZM25.814 27.2184C24.2785 27.2184 23.0273 25.9672 23.0273 24.4317C23.0273 22.8962 24.2785 21.645 25.814 21.645C27.3495 21.645 28.6007 22.8962 28.6007 24.4317C28.6007 25.9672 27.3685 27.2184 25.814 27.2184Z"
      fill="#0068FF"
    />
    <path
      d="M40.4867 19.6162C37.8516 19.6162 35.7095 21.7584 35.7095 24.3934C35.7095 27.0285 37.8516 29.1707 40.4867 29.1707C43.1217 29.1707 45.2639 27.0285 45.2639 24.3934C45.2639 21.7584 43.1217 19.6162 40.4867 19.6162ZM40.4867 27.2181C38.9322 27.2181 37.681 25.9669 37.681 24.4124C37.681 22.8579 38.9322 21.6067 40.4867 21.6067C42.0412 21.6067 43.2924 22.8579 43.2924 24.4124C43.2924 25.9669 42.0412 27.2181 40.4867 27.2181Z"
      fill="#0068FF"
    />
    <path
      d="M29.4562 29.0944H30.5747V19.957H28.6221V28.2793C28.6221 28.7153 29.0012 29.0944 29.4562 29.0944Z"
      fill="#0068FF"
    />
  </svg>
);
export const TelegramIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="injected-svg"
      role="img"
      color="#4a90e2"
    >
      <path
        d="M14.7041 19.6345L14.7041 19.6344L12.0442 16.6103C10.7274 15.1131 10.5714 14.4552 10.6581 14.3134L11.6564 13.5094L15.7027 10.3444C16.029 10.0892 16.0866 9.61786 15.8314 9.29159C15.5762 8.96533 15.1048 8.90772 14.7785 9.16292L10.728 12.3311L9.50989 13.3253C9.22553 13.6305 9.04418 14.1524 9.24197 14.8946C9.42654 15.5872 9.94427 16.5026 11.0466 17.7593L10.6395 18.5622C10.3765 18.9277 10.1324 19.2671 9.90771 19.4997C9.68445 19.7308 9.27877 20.0705 8.71374 19.9581C8.15614 19.8472 7.90592 19.3862 7.78203 19.0904C7.65621 18.7899 7.54964 18.3824 7.43402 17.9404L6.93252 16.0239C6.65396 14.9594 6.55777 14.6534 6.37651 14.4282C6.35363 14.3998 6.3298 14.3723 6.30509 14.3459C6.11372 14.141 5.84345 14.0149 4.8535 13.6181L4.79927 13.5963C3.82368 13.2053 3.02006 12.8832 2.45798 12.5667C1.91344 12.2601 1.3254 11.8144 1.25775 11.0623C1.24724 10.9454 1.24742 10.8278 1.25829 10.7109C1.32825 9.95901 1.91775 9.51516 2.46325 9.21037C3.02632 8.89576 3.83094 8.57633 4.80773 8.18854L16.7918 3.43052C18.0177 2.94379 19.02 2.54579 19.8076 2.36434C20.6106 2.17935 21.4401 2.15976 22.0901 2.76101C22.7273 3.35039 22.8036 4.18068 22.7242 5.01747C22.6454 5.8477 22.3864 6.92742 22.0669 8.2593L19.6472 18.3463L19.6472 18.3464C19.4436 19.1954 19.2717 19.9121 19.0655 20.4321C18.8573 20.9575 18.5233 21.5216 17.8484 21.7001C17.1654 21.8807 16.6009 21.544 16.1719 21.1809C15.7505 20.8243 15.2699 20.2779 14.7041 19.6345Z"
        fill="#4a90e2"
      ></path>
    </svg>
  );
};
export const AddIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="injected-svg"
    role="img"
    color='#ffffff'
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.75C12.6904 2.75 13.25 3.30964 13.25 4V20C13.25 20.6904 12.6904 21.25 12 21.25C11.3096 21.25 10.75 20.6904 10.75 20V4C10.75 3.30964 11.3096 2.75 12 2.75Z"
      fill='#ffffff'
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 12C2.75 11.3096 3.30964 10.75 4 10.75H20C20.6904 10.75 21.25 11.3096 21.25 12C21.25 12.6904 20.6904 13.25 20 13.25H4C3.30964 13.25 2.75 12.6904 2.75 12Z"
      fill='#ffffff'
    />
  </svg>
);
export const CancelIconV2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    className="injected-svg"
    role="img"
    color="#4a90e2"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10.2623L18.0123 4.25L19.75 5.98775L13.7377 12L19.75 18.0123L18.0123 19.75L12 13.7377L5.98775 19.75L4.25 18.0123L10.2623 12L4.25 5.98775L5.98775 4.25L12 10.2623Z"
      fill="#4a90e2"
    />
  </svg>
);
export const HeartIcon = (props) => (
  <svg
    aria-label="Thick"
    className="x1lliihq x1n2onr6 x5n08af"
    fill="currentColor"
    height="24"
    role="img"
    viewBox="0 0 24 24"
    width="24"
    {...props}
  >
    <title>Thick</title>
    <path d="M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z" />
  </svg>
);
export const CommentIcon = (props) => (
  <svg
    aria-label="Bình luận"
    className="x1lliihq x1n2onr6 x5n08af"
    fill="currentColor"
    height="24"
    role="img"
    viewBox="0 0 24 24"
    width="24"
    {...props}
  >
    <title>Bình luận</title>
    <path
      d="M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
export const ShareIcon = (props) => (
  <svg
    aria-label="Chia sẻ bài viết"
    className="x1lliihq x1n2onr6 x1roi4f4"
    fill="currentColor"
    height="24"
    role="img"
    viewBox="0 0 24 24"
    width="24"
    {...props}
  >
    <title>Chia sẻ bài viết</title>
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      x1="22"
      x2="9.218"
      y1="3"
      y2="10.083"
    />
    <polygon
      fill="none"
      points="11.698 20.334 22 3.001 2 3.001 9.218 10.084 11.698 20.334"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
export const RedHeartIcon = (props) => (
  <svg
    aria-label="Bỏ thích"
    className="x1lliihq x1n2onr6 xxk16z8"
    fill="currentColor"
    height="24"
    role="img"
    viewBox="0 0 48 48"
    width="24"
    {...props}
  >
    <title>Bỏ thích</title>
    <path d="M34.6 3.1c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5s1.1-.2 1.6-.5c1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z" />
  </svg>
);
export const ExchangeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      color="#4a90e2"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C11.3876 4 10.7924 4.06863 10.2213 4.19823C9.68269 4.32044 9.147 3.9829 9.02479 3.4443C8.90258 2.90571 9.24012 2.37002 9.77871 2.24781C10.4941 2.08549 11.2377 2 12 2C17.5228 2 22 6.47715 22 12C22 14.482 21.0953 16.7526 19.5994 18.5H20.5C21.0523 18.5 21.5 18.9477 21.5 19.5C21.5 20.0523 21.0523 20.5 20.5 20.5H16.9767C16.4244 20.5 15.9767 20.0523 15.9767 19.5V16C15.9767 15.4477 16.4244 15 16.9767 15C17.529 15 17.9767 15.4477 17.9767 16V17.3181C19.2361 15.904 20 14.0411 20 12C20 7.58172 16.4183 4 12 4ZM2.5 4.51555C2.5 3.96326 2.94772 3.51555 3.5 3.51555H7C7.55228 3.51555 8 3.96326 8 4.51555V8C8 8.55228 7.55228 9 7 9C6.44772 9 6 8.55228 6 8V6.70816C4.75451 8.11907 4 9.97153 4 12C4 16.4183 7.58172 20 12 20C12.6124 20 13.2076 19.9314 13.7787 19.8018C14.3173 19.6796 14.853 20.0171 14.9752 20.5557C15.0974 21.0943 14.7599 21.63 14.2213 21.7522C13.5059 21.9145 12.7623 22 12 22C6.47715 22 2 17.5228 2 12C2 9.52533 2.89933 7.26091 4.3873 5.51555H3.5C2.94772 5.51555 2.5 5.06783 2.5 4.51555Z"
        fill="#4a90e2"
      />
    </svg>
  );
};